// Reads a JWT payload without validating it. The server is the only authority on whether a token
// is valid; the client only needs the claims to decide when to ask for a new one.
export function decodeJwtPayload(token: string | null | undefined): Record<string, unknown> | null {
  try {
    const payload = token?.split('.')[1];

    if (!payload) {
      return null;
    }

    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), '=');
    const json = decodeURIComponent(
      atob(padded)
        .split('')
        .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join(''),
    );
    const claims = JSON.parse(json) as unknown;

    return typeof claims === 'object' && claims !== null && !Array.isArray(claims)
      ? (claims as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}

// The `exp` claim as epoch milliseconds, or null when it is missing or not a positive number.
export function readJwtExpiry(token: string | null | undefined): number | null {
  const exp = decodeJwtPayload(token)?.['exp'];

  return typeof exp === 'number' && Number.isFinite(exp) && exp > 0 ? exp * 1000 : null;
}
